import { FC } from 'react'

import { ColoredPaper, ColoredPaperProps } from '../Paper/ColoredPaper'

// eslint-disable-next-line
const severities: any = {
  error: 'errorLight',
  warning: 'warningLight',
  info: 'ltblue',
  success: 'successLight',
}

export interface AlertProps extends ColoredPaperProps {
  severity: string
  fontSize?: string
}
export const Alert: FC<AlertProps> = ({
  severity = '',
  fontSize = '0.875rem',
  elevation = 1,
  ...props
}) => {
  return (
    <ColoredPaper
      variant={severities[severity]}
      elevation={elevation}
      sx={{ fontSize }} 
      {...props}
    />
  )
}

export default Alert
